export default __webpack_public_path__ + "static/media/vn.cb9fa057.svg";